"use strict";exports.__esModule = true;exports.default = void 0;var rootSvg;var _default =

{
  onMount() {
    // Create a hidden svg to store all symbols on startup.
    if (!rootSvg) {
      rootSvg = document.createElement('svg');
      var rootDiv = document.createElement('div');
      rootDiv.hidden = true;
      document.body.insertBefore(rootDiv, document.body.firstChild);
      rootDiv.appendChild(rootSvg);
    }

    // If there were any symbols rendered then we move them to the svg above after rendering them.
    var defs = this.getEl('defs');

    if (defs) {
      if (this.input && this.input._themes) {
        defs.innerHTML = this.input._themes();
      }
      var symbol = defs.querySelector('symbol');
      defs.parentNode.removeChild(defs);

      if (symbol) {
        rootSvg.appendChild(symbol);
      }
    }
  } };exports.default = _default;module.exports = exports.default;